import React, { useEffect,useState,useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { NavLink } from 'react-router-dom';
import { fetchJobs,filterJobs } from '../redux/actions/jobsActions';
import { useDispatch, useSelector } from 'react-redux';
import debounce from "lodash/debounce";
import Spinner from 'react-bootstrap/Spinner';
import notfound from '../images/not-found.png'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { addApplication } from '../redux/actions/applicationsActions';

function UserDashboard() {
    const jobs = useSelector(state=> state.jobsReducer.jobs)
    const [searchText,setSearchText] = useState('')
    const [loading,setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [candidate,setCandidate] = useState({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
    const [error,setError] = useState({ name: '', phone: '',email: '',resume: '',reference:''})
    const [emailError,setEmailError] = useState("")
    const [addloading,setAddLoading] = useState(false)
    const [job,setJob] = useState(null)

    const dispatch = useDispatch()

    useEffect(()=>{
        onFetchJobs()
    },[])

    const handleClose = () => {
        setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
        setError({ name: '', phone: '',email: '',resume: '',reference:''})
        setJob(null)
        setShow(false)
    };

    const handleShow = (data) => {
        setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
        setError({ name: '', phone: '',email: '',resume: '',reference:''})
        setJob(data);
        setShow(true)
    };
    const onFetchJobs = async(params) =>{
        setLoading(true)
        const res = await dispatch(fetchJobs())
        if(res.success){
            setLoading(false)
        }else if(!res.success){
            setLoading(false)
        }
    }

    const handleSearch = async(query)=>{
        setSearchText(query)
        setLoading(true)
        let res;
        if(query.trim().length){
            res = await dispatch(filterJobs({position:query.trim()}))
        }else{
            res = await dispatch(fetchJobs())
        }
        if(res.success){
            setLoading(false)
        }else if(!res.success){
            setLoading(false)
        }
    }

    const debouncedHandleSearch = useCallback(debounce(handleSearch, 100), []);

    const onChange = (e) =>{
        const { name, value } = e.target;
        if(name=="resume"){
            let filetype = value.substr(value.lastIndexOf('.'));
            if ((filetype.toLowerCase() != ".docx") &&
            (filetype.toLowerCase() != ".doc") &&
            (filetype.toLowerCase() != ".pdf") &&
            (filetype.toLowerCase() != ".rtf") &&
            (filetype != "")){
                setCandidate((prev) => ({
                    ...prev,
                    [name]: ""
                }));
                setCandidate((prev) => ({
                    ...prev,
                    fileobject: null
                }));
                setError((prev) => ({
                    ...prev,
                    [name]: "File format is not valid",
                }));
                return false
            }else{
                setCandidate((prev) => ({
                    ...prev,
                    [name]: value,
                }));
                setCandidate((prev) => ({
                    ...prev,
                    fileobject: e.target.files[0],
                }));
                setError((prev) => ({
                    ...prev,
                    [name]: '',
                }));
            }
        }else{
            setCandidate((prev) => ({
                ...prev,
                [name]: value,
            }));
            setError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }

    const newCandidate = async() =>{
        const candidatedata = candidate
        const {name,email,resume,reference,phone,fileobject} = candidate
        const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validate = true;
        if(name==''){
            setError((prev) => ({
                ...prev,
                name: "Please Enter Your Name",
            }));
            validate = false
        }
        if(email==''){
            setError((prev) => ({
                ...prev,
                email: "Please Enter Your Email Address",
            }));
            validate = false
        }else if(!regEx.test(email)){
            setError((prev) => ({
                ...prev,
                email: "Email Address is not valid",
            }));
            validate = false
        }
        if(phone==''){
            setError((prev) => ({
                ...prev,
                phone: "Please Enter Your Phone Number",
            }));
            validate = false
        }else if(phone.length!==10){
            setError((prev) => ({
                ...prev,
                phone: "Phone Number must be of 10 digit",
            }));
            validate = false
        }
        if(reference==''){
            setError((prev) => ({
                ...prev,
                reference: "Reference must be required",
            }));
            validate = false
        }
        if(resume=='' || fileobject==null){
            setError((prev) => ({
                ...prev,
                resume: "Please Select Resume File",
            }));
            validate = false
        }
        if(validate){
            candidatedata.status = true
            candidatedata.position = job.position
            setAddLoading(true)
            const res = await dispatch(addApplication(candidatedata))
            if(res.success){
                setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
                setShow(false)
            }else if(!res.success){
                if(res.error.code==="23505"){
                    setEmailError("Email Address must be unique")
                }
            }
            setAddLoading(false)
        }
    }

    const activeJobs = jobs.filter((item)=>{return item.status===true})

    return (
        <div>
        <div className={`main-content navbar-ful`}>
            <div className=''>
                <Container fluid>
                    <Row className='find-job text-center'>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='search-box'>
                            <h1 className='text-white pb-4'>We offer {activeJobs.length} job vacancies right now!</h1>
                            <InputGroup className="mb-3 search-input big-input">
                                <Form.Control
                                placeholder="Search Jobs..."
                                aria-describedby="basic-addon2"
                                type='search'
                                onChange={(e) => debouncedHandleSearch(e.target.value)}
                                value={searchText} 
                                name="search"
                                />
                                {/* <InputGroup.Text id="basic-addon2" type='button' className='btn btn-primary'>Find Jobs</InputGroup.Text> */}
                            </InputGroup>
                        </Col>
                        <div className='bg-blacks'></div>
                    </Row>
                    

                    <Row className='pt-4 d-flex'>
                        {/* Recent Jobs */}
                        {(!loading&&activeJobs.length!==0) &&
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='pb-3'>
                            <h3 className='mb-0'>Recent Active Jobs</h3>
                        </Col>}
                        {loading?
                        <div className='spinner load-height'><Spinner animation="grow"/></div>:
                        <>
                        {(!loading&&activeJobs.length==0)?
                        <Container>
                        <Row>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className=''>
                                <div className="d-flex flex-column justify-content-center px-md-5 py-4 px-4 align-items-center">
                                    <img src={notfound} width={200}/>
                                    <h2 className='text-center mt-2'>{`No ${searchText.length?"Match":""} Vacancies Found`}</h2>
                                </div>
                            </Col>
                        </Row>
                         </Container>:
                        activeJobs?.map((item,index)=>{
                        return (
                        <Col key={index} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3 d-flex'>
                            <div className='job_box_user das3'>
                                <h4 className="text-dark c_name mb-0">{item.position}</h4>
                                <div className="dash-count bill_box das3 user_dash">
                                    <div className="dash-counts">
                                        <h5 className="text-dark text-green">Location :<span>{item.location}</span></h5>
                                        <h5 className="text-dark">Post Date : {new Date(item.created_at).getDate() + '-' +  (new Date(item.created_at).getMonth() + 1) + '-' + new Date(item.created_at).getFullYear()}</h5>
                                    </div>
                                    <div className="dash-imgs">
                                    <h5 className="text-dark">Job Type : <span>{item.type}</span></h5>
                                        <h5 className="text-dark">Required Experience : <span>{item.experience}</span></h5>
                                    </div>
                                </div>
                                {/* <h4 className="text-dark c_name mb-0">Job Summary:</h4>
                                <p className='mt-2' dangerouslySetInnerHTML={{__html: item.description}}></p> */}
                                <div className='card-buttons'>
                                    <Button className='btn btn-primary' onClick={()=>handleShow(item)}>Apply Now</Button>
                                    <NavLink to='/job-details' state={{ data: { item } }} className='btn view-all'>Read More</NavLink>
                                </div>
                            </div>
                        </Col>)
                        })}
                        </>}
                        <Modal show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Apply For This Job</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form className='mt-1 mb-2'>
                                        <Row>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Name</Form.Label>
                                                    <Form.Control name="name" value={candidate.name} onChange={(e)=>onChange(e)} type="text" placeholder="Name...." required/>
                                                    {error.name && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.name}</small>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Phone No</Form.Label>
                                                    <Form.Control name="phone" value={candidate.phone} onChange={(e)=>onChange(e)} type="number" placeholder="Phone No...." required/>
                                                    {error.phone && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.phone}</small>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Email Address</Form.Label>
                                                    <Form.Control name="email" value={candidate.email} onChange={(e)=>onChange(e)} type="email" placeholder="Email...." required/>
                                                    {error.email && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.email}</small>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Reference</Form.Label>
                                                    <Form.Control name="reference" value={candidate.reference} onChange={(e)=>onChange(e)} type="text" placeholder="Reference...." required/>
                                                    {error.reference && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.reference}</small>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <Form.Group className="mb-0" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Upload Resume</Form.Label>
                                                    <Form.Control name="resume" value={candidate.resume} onChange={(e)=>onChange(e)} type="file" placeholder="file...." required/>
                                                    {error.resume && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.resume}</small>}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>
                                    {emailError && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{emailError}</small>}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={newCandidate} disabled={addloading}>
                                    Submit Application
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </Row>
                    <Row className='bg-dark mt-5'>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-3'>
                            <p className='text-white text-center'>2023 © Design by Logicode.</p>
                        </Col>
                    </Row>
            </Container>
            </div>
        </div>
        </div>
    );
}

export default UserDashboard;
